// Cache en memoria
const memoryCache = new Map<string, any>();

// Función para cachear en memoria
export const cacheData = (key: string, data: any, ttl: number = 5 * 60 * 1000) => {
  memoryCache.set(key, {
    data,
    expiry: Date.now() + ttl
  });
};

// Función para obtener datos cacheados
export const getCachedData = (key: string) => {
  const cached = memoryCache.get(key);
  if (!cached) return null;
  
  if (Date.now() > cached.expiry) {
    memoryCache.delete(key);
    return null;
  }
  
  return cached.data;
};

// Función para precargar recursos críticos
export const preloadResources = () => {
  const resources = [
    '/manifest.json',
    'https://imagenesgraficos.s3.eu-west-3.amazonaws.com/Logo+ATIA+Blanco+400x200.png'
  ];

  resources.forEach(url => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = url;
    link.as = url.endsWith('.json') ? 'fetch' : 'image';
    document.head.appendChild(link);
  });
};

// Función para medir performance
export const measurePerformance = (metricName: string) => {
  if ('performance' in window && 'mark' in performance) {
    const startMark = `${metricName}_start`;
    const endMark = `${metricName}_end`;
    
    performance.mark(startMark);
    
    return () => {
      performance.mark(endMark);
      performance.measure(metricName, startMark, endMark);
      
      const entries = performance.getEntriesByName(metricName);
      const duration = entries[entries.length - 1].duration;
      
      console.debug(`${metricName}: ${duration.toFixed(2)}ms`);
    };
  }
  
  return () => {};
};